import { render, staticRenderFns } from "./shequ.vue?vue&type=template&id=9ecad3ae&scoped=true&"
import script from "./shequ.vue?vue&type=script&lang=js&"
export * from "./shequ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecad3ae",
  null
  
)

export default component.exports